import React, { useMemo } from "react";
import { Briefcase, Building2, Camera, Users } from "lucide-react";
import SearchableSelect, { crmItem } from "./SearchableSelect";
import { Spinner } from "./shared";

export default function CrewTab({ record, setField, crm, crmLoading }) {
  const groups = useMemo(() => {
    const all = crm.map((c) => ({ raw: c, ...crmItem(c) }));
    const crew = all.filter((i) => ["Cameraman", "Producer", "Model", "Escort", "Studio"].includes(i.role));
    return {
      cast: all.filter((i) => ["Model", "Escort"].includes(i.role)),
      studios: all.filter((i) => i.role === "Studio"),
      cameramen: crew.filter((i) => i.role !== "Studio"),
      producers: crew.filter((i) => i.role !== "Studio"),
    };
  }, [crm]);

  if (crmLoading) return <Spinner label="Loading CRM people..." />;

  return (
    <div className="space-y-5">
      <SearchableSelect testId="crew-cast" label="CAST (Models & Escorts)" icon={<Users size={13} className="inline mr-1" />}
        items={groups.cast} value={record.cast_crm_ids || []} onChange={(v) => setField("cast_crm_ids", v)} />
      <SearchableSelect testId="crew-studio" label="STUDIO (Single)" icon={<Building2 size={13} className="inline mr-1" />}
        items={groups.studios} multi={false} noneLabel="None" value={record.studio_crm_id || null}
        onChange={(v) => setField("studio_crm_id", v)} />
      <SearchableSelect testId="crew-cameraman" label="CAMERAMAN" icon={<Camera size={13} className="inline mr-1" />}
        items={groups.cameramen} value={record.cameraman_crm_ids || []} onChange={(v) => setField("cameraman_crm_ids", v)} />
      <SearchableSelect testId="crew-producer" label="PRODUCER" icon={<Briefcase size={13} className="inline mr-1" />}
        items={groups.producers} value={record.producer_crm_ids || []} onChange={(v) => setField("producer_crm_ids", v)} />
    </div>
  );
}
